import http from "./HttpService";
import axios from "axios";

const endpoint = process.env.VUE_APP_BASE_URL;

export const updateFraudException = (accountId, data) => {
  return http.patch(`/Fraud/${accountId}/exception`, {...data}, {
    baseURL: endpoint,
  });
};



export const fetchFraudExceptionStatus = (accountId) => {
  return http.get(`/Fraud/${accountId}/exceptions`, {
    baseURL: endpoint,
  });
};

export const fetchUserFraudData = (accountId, symbol) => {
  return http.get(`/Fraud/${accountId}/score/cryptoWithdrawal`, {
    baseURL: endpoint,
    params: {
      symbol
    },
  });
};

